import * as Sentry from '@sentry/browser';

export class SentryService {
    public captureException(error, callback?): string {
        return Sentry.captureException(error, callback);
    }
}
